<template>
  <Modal @close="closeModal" :wide="false">
    <h1>{{ params.title || 'Välj' }}</h1>

    <div class="multiselect-container">
      <div v-for="option in params.options" :key="option.id" class="option-row">
        <Checkbox 
          :label="option.name"
          label-position="right"
          :value="true"
          :valuebinder.sync="localSelection[option.id]"
          type="checkbox"
          special-class="wishes"
        />
      </div>
      <div style="clear:both;"></div>
    </div>

    <div class="center" style="margin-top: 2rem;">
      <button class="small" @click="save">{{ 'Spara' }}</button>
    </div>
  </Modal>
</template>

<script>
import Modal from '@/components/components/Modal';
import Checkbox from '@/components/components/Checkbox';
import { mapMutations } from 'vuex';

export default {
  props: {
    params: {},
  },
  components: {
    Modal,
    Checkbox,
  },
  data() {
    return {
      localSelection: {},
    };
  },
  beforeMount() {
    const selectedList = this.params.selected || [];
    this.params.options.forEach((opt) => {
      this.$set(
        this.localSelection,
        opt.id,
        selectedList.includes(opt.id) ||
          selectedList.includes(Number(opt.id)) ||
          selectedList.includes(String(opt.id)),
      );
    });
  },
  methods: {
    ...mapMutations([
      'closeModal',
    ]),
    save() {
      const selectedIds = Object.keys(this.localSelection)
        .filter(key => this.localSelection[key])
        .map(key => (isNaN(Number(key)) ? key : Number(key)));

      this.params.click(selectedIds);
      this.closeModal();
    },
  },
};
</script>

<style scoped lang="stylus">
.multiselect-container
  display flex
  flex-direction column
  gap 12px

.option-row
  text-align left

.center
  text-align center
</style>



// WEBPACK FOOTER //
// AdminMultiSelectModal.vue?58890633